"use client";

import dynamic from "next/dynamic";

export const RiveAnimation = dynamic(() => import("./RiveAnimation").then(mod => mod.RiveAnimation));
